import { Box, Button, styled } from "@mui/material";

export const BottomActionArea = styled(Box)({
  bottom: 0,
  left: 0,
  display: "flex",
  justifyContent: "space-evenly",
  width: "100%",
  padding: "16px 16px 24px",
  zIndex: 999,
  gap: 24,
});

export const BottomActionButton = styled(Button)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "24px",
  textAlign: "center",
  textTransform: "none",
  backgroundColor: theme.palette.primary.main,
  borderRadius: "100px",
  padding: "12px 32px",
  color: "white",
  width: "100%",
  minWidth: "150px",
  "&:focus, &:hover": {
    cursor: "pointer",
    backgroundColor: theme.palette.primary.dark,
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.action.disabledBackground,
    // Add before pseudo elemento to avoid transparency on disabled state
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "white",
      borderRadius: "inherit",
      zIndex: -1,
    },
  },
}));

export const MainActionButton = styled(Button)(({ variant, theme }) => ({
  display: "flex",
  width: "100%",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "24px",
  textAlign: "center",
  textTransform: "none",
  color: theme.palette.primary.dark,
  background: theme.palette.primary.extralight,
  ...(variant === "outlined" && {
    border: `1px solid ${theme.palette.primary.dark};`,
  }),
  borderRadius: "100px",
  padding: "12px 32px",
  minWidth: "150px",
  "&:hover, &:focus": {
    cursor: "pointer",
    background: theme.palette.primary.hover,
    ...(variant === "outlined" && {
      border: `1px solid ${theme.palette.primary.dark}`,
    }),
  },
  "&:disabled": {
    background: theme.palette.action.disabledBackground,
  },
}));

export const SecondaryActionButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "useBackground",
})<{ useBackground?: boolean; textDecoration?: string }>(
  ({ useBackground, textDecoration, theme }) => ({
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "19px",
    textAlign: "center",
    textTransform: "none",
    width: "100%",
    ...(textDecoration && { textDecoration }),
    color: theme.palette.primary.main,
    background: useBackground ? theme.palette.primary.extralight : "transparent",
    border: "none",
    borderRadius: "100px",
    padding: "12px 32px",
    minWidth: "150px",
    "&:focus, &:hover": {
      cursor: "pointer",
      background: useBackground
        ? theme.palette.primary.hover
        : theme.palette.primary.extralight,
      ...(textDecoration && { textDecoration }),
    },
    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
    },
  }),
);

export const ButtonsContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
  width: "100%",
  gap: "12px",
  paddingBottom: "12px",
});

export const ButtonsColumnContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  gap: "12px",
  paddingBottom: "12px",
});

export const ExtraWhiteSpace = styled(Box)({
  height: "91px",
});

export const LargeExtraWhiteSpace = styled(Box)({
  height: "250px",
});
